import { __assign } from "tslib";
import mergeWith from 'lodash/mergeWith';
import classnames from 'classnames';
/**
 * RCE merge will skip customisations that are not in the base
 * this means you need to fill the base with empty rules. I didn't
 * like that so this adds missing keys into the base before the merge.
 *
 * @param base
 * @param custom
 */
export default function mergeTheme(base, custom) {
    return mergeWith(__assign({}, base), custom || {}, function (defaultStyleClassName, themeClassName) {
        return classnames(defaultStyleClassName, themeClassName);
    });
}
//# sourceMappingURL=mergeTheme.js.map